import { useParams } from 'react-router-dom';
import { AddApprover } from './AddApprover';
import { useGetInvitedMembers } from '../../../../services/user.service';
import toast from 'react-hot-toast';
import { checkIsLockedAutomation } from '../../../../utils/lockAutomation';
import { Flex, Loader, Modal } from '@mantine/core';
import { useGetWorkflowById } from '../../../../services/workflow.services';

/**
 * @param {{
 *   id?: string;
 *   periodId?: any;
 *   onClose?: any;
 *   isOpen?: any;
 *   currentUser?: any;
 *   selectedPeriod?: any;
 * }} props
 */
export function ApproverDrawer({ periodId, onClose, isOpen, currentUser, selectedPeriod }) {
  const { id, workflowId } = useParams();
  const isLocked = checkIsLockedAutomation(selectedPeriod, currentUser);
  const { data: workflow } = useGetWorkflowById({
    id: workflowId || id,
    queryParams: {
      enabled: !!workflowId || !!id
    }
  });

  const isFormPF = workflow?.report_type === 'Form PF';

  // One unified screen — access config + approval status + add/remove, all in the same list.
  const { isFetching } = useGetInvitedMembers({
    queryKey: 'invitedMembers',
    params: {
      period_id: periodId,
      workflow_id: id || workflowId
    },
    queryOptions: {
      enabled: !!periodId && isOpen,
      cacheTime: 0,
      staleTime: 0,
      onError: () => {
        toast.error('Server error');
      }
    }
  });

  if (isFetching) {
    return (
      <Modal
        title="Reviewers and approvals"
        size={window.innerWidth < 1000 ? '94%' : '880px'}
        centered
        opened={isOpen}
        onClose={onClose}
      >
        <Flex justify="center" align="center" style={{ height: 'min(72vh, 460px)' }}>
          <Loader size="lg" />
        </Flex>
      </Modal>
    );
  }

  return (
    <AddApprover
      isOpen={isOpen}
      onClose={onClose}
      periodId={periodId}
      isFormPF={isFormPF}
      isLocked={isLocked}
    />
  );
}
